import { Component } from '@angular/core';
import {Events, IonicPage, ModalController, NavController, NavParams, Platform, PopoverController} from 'ionic-angular';
import {UserStatsProvider} from "../../providers/user-stats/user-stats";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import * as moment from "moment";
import {UserStats} from "../../providers/api-course-data/user-state-dto";
import {DatePickerPopoverPage} from "../date-picker-popover/date-picker-popover";
import {ApiProvider} from "../../providers/api/api";
import {WheelSelector} from "@ionic-native/wheel-selector";

/**
 * Generated class for the AppWeightUpdatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-weight-update',
  templateUrl: 'app-weight-update.html',
})
export class AppWeightUpdatePage {

  selectedWeight:number;

  selectedDateFormatted: string;
  selectedDate: Date = new Date();
  minDate: Date = new Date(2018,1,1);
  maxDate: Date = new Date();
  errorVisible: boolean;
  isNativeEnv: boolean = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private stats: UserStatsProvider,
    private progress: UserProgressStateProvider,
    public contentTranslation: ContentTranslationProvider,
    public popoverCtrl: PopoverController,
    private api: ApiProvider,
    private events: Events,
    public platform: Platform,
    private selector: WheelSelector
  ) {
    moment.updateLocale('de',function() {});
    this.selectedDateFormatted = moment().format('dd, ll')

    if(this.navParams.get('date')) {
      this.selectedDate = moment(this.navParams.get('date')).toDate();
      this.formatSelectedDate();
    }
  }

  initValue: number = 100;

  ionViewDidLoad() {
    if(!((window as any).cordova)) {
      this.isNativeEnv = false;
    }
    if (this.navParams.get('currentVal')) {
      this.initValue = parseFloat(this.navParams.get('currentVal'));
    }
  }

  formatSelectedDate() {
    // if(moment(this.selectedDate).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
    //   this.selectedDateFormatted = this.contentTranslation.translateContent('Weight today');
    // } else {
      this.selectedDateFormatted = moment(this.selectedDate).format('dd, ll')
    // }
  }

  updateFormattedDate(event) {
    this.selectedDate = event;
    this.formatSelectedDate();
  }
  hideError() {
    this.errorVisible = false;
  }

  goNext() {
    if (!this.selectedWeight) {
      this.errorVisible = true;
      return;
    }


    this.api.callPut('/weights/'+moment(this.selectedDate).format('YYYYWW'), {
      currentValue: this.selectedWeight
    }).subscribe((data) => {
      this.events.publish('stats:weight:update', {data})
      this.navCtrl.pop();
    })
  }

  openedPopover: any;
  openDatePickerPopover(event) {
    this.openedPopover = this.popoverCtrl.create(
      DatePickerPopoverPage,
      {
        pastDateSelect: true,
        valueUpdated: (selectedDate) => {
          this.selectedDate = moment(selectedDate).toDate();
          this.formatSelectedDate();
        }
      },
      {cssClass: 'date-picker-popover-container'}
    );
    this.openedPopover.present({
      ev: event,
    });
  }

  chooseWeight() {
    let weightOptions = [];
    for(let i = 200; i >= 25; i--) {
      weightOptions.push({description: (i).toString(), name: i, value: i})
    }

    let gramOptions = [];
    for(let i = 0; i < 10; i++) {
      gramOptions.push({description: (i).toString(), name: i, value: i/10})
    }


    let predefinedValue = this.selectedWeight || this.initValue;
    console.log(predefinedValue, ((predefinedValue - Math.floor(predefinedValue))*10).toString());

    let defaultItems: any = [
      {"index": 0, value: ''},
      {"index": 1, value: Math.floor(predefinedValue).toString()},
      {"index": 2, value: ''},
      {"index": 3, value: (Math.round((predefinedValue - Math.floor(predefinedValue))*10)).toString()},
      {"index": 4, value: ''},
    ];

    this.selector.show({
      title: this.contentTranslation.translateContent('Select weight'),
      positiveButtonText: this.contentTranslation.translateContent('Wheel OK'),
      negativeButtonText: this.contentTranslation.translateContent('Wheel Cancel'),
      defaultItems: defaultItems,
      items: [
        [{description: ''}],
        weightOptions,
        [{description: ','}],
        gramOptions,
        [{description: ''}],
      ],
    }).then(
      result => {
        console.log(result);
        this.selectedWeight = weightOptions[result[1].index].value + gramOptions[result[3].index].value;
      },
      err => console.log('Error: ', err)
    );

  }



}



// WEBPACK FOOTER //
// ./src/pages/app-weight-update/app-weight-update.ts